// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"c9b2542b","649":"1a7bedd3","812":"827dac37","849":"82857374"}[chunkId] + ".css";
};